import { useEffect } from 'react';

import { useSavedDocumentViewActions } from '../store';

const POLLING_INTERVAL_MS = 30_000;

/** Loads the comments and ratings, then reads them again while the view is visible. */
export const useSavedDocumentPolling = (isVisible: boolean): void => {
  const savedDocumentViewActions = useSavedDocumentViewActions();

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    savedDocumentViewActions.fetchSavedDocument();
    const intervalId = window.setInterval(() => {
      savedDocumentViewActions.fetchSavedDocument();
    }, POLLING_INTERVAL_MS);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [isVisible, savedDocumentViewActions]);
};
